import "@/components/global";
import "./assets/css/fonts.css";
import "./assets/css/tailwind.css";
import "vue-loading-overlay/dist/vue-loading.css";

import App from "./App.vue";
import Loading from "vue-loading-overlay";
import Vue from "vue";
import Vuelidate from "vuelidate";
import router from "./router";
import store from "./store";
import VueMask from "v-mask";
Vue.use(VueMask);

Vue.use(Vuelidate);
Vue.use(
  Loading,
  {
    color: "#333F48",
    loader: "dots",
    canCancel: false,
    isFullPage: true,
    // sun-50 (#FFFDF5) — the overlay covers the page in the app background
    // color rather than the plugin's default white. Set here as an inline
    // style because vue-loading.css is imported after tailwind.css and would
    // otherwise win over a stylesheet override of .vld-background.
    backgroundColor: "#FFFDF5",
    opacity: 0.8
  },
  {}
);
Vue.component("loading", Loading);
Vue.config.productionTip = false;

/** Use the following filters in templates using mustache interpolation to format text.
 * @example {{ price | currency }} formats the 'price' according to 'currency' function
 * @example {{ orderDate | date }} formats the 'orderDate' according to 'date' function
 */
Vue.filter("currency", function(value: number): string {
  const num = (Math.round(value * 100) / 100).toFixed(2);
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
});

Vue.filter("date", function(date: Date): string {
  const dt = new Date(date);
  return dt.toLocaleDateString("en-US");
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
